/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';
import { CustomerStatusEnum } from './customer-status-enum';

export interface ProfileUpdate {
  readonly address: Address;
  readonly customer_status: CustomerStatusEnum;
  readonly d_number: string | null;
  readonly pnr: string | null;
  readonly utl: string | null;
  readonly customer_status_explanation: string | null;
}
export namespace ProfileUpdate {}
